var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-quarter"},[_c('StepProgressBar')],1),_c('div',{staticClass:"column",class:{
      'content' : _vm.$route.name !== 'courses',
      'bg-1' : _vm.$route.name !== 'contract' && _vm.$route.name !== 'training', 
      'bg-2' : _vm.$route.name === 'contract',
      'courses' : _vm.$route.name === 'courses'}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }